module.exports = __webpack_public_path__ + "media/images/front/home_video_poster-3d8bea9c226847aa2b26f1560510b769.jpg";